import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ScrollspyNav from 'react-scrollspy-nav';
import Navbar from './component/Navbar';
import Jumbotron from './component/Jumbotron';
import Destination from './component/Destination';
import Galery from './component/Galery';
import Travel from './component/Travel';
import Footer from './component/Footer';
import NavbarDetail from './component/NavbarDetail';
import DestinationDetail from './component/DestinationDetail';

function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route path="/detail">
            <NavbarDetail />
            <DestinationDetail />
          </Route>
          <Route path="/">
            <ScrollspyNav scrollTargetIds={["Home", "Destination", "Galery", "Travel", "Footer"]} scrollDuration="1000">
              <Navbar />
              <div id="Home">
                <Jumbotron />
              </div>
              <div id="Destination">
                <Destination />
              </div>
              <div id="Galery">
                <Galery />
              </div>
              <div id="Travel">
                <Travel />
              </div>
              <div id="Footer">
                <Footer />
              </div>
            </ScrollspyNav>
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
